module.exports = __webpack_public_path__ + "static/img/2_61.fcc27cc4.jpg";